import routesLimited from '@/constants/routesLimited'
import { castRouteIds } from 'plugins/router/routes/castRouteIds'
import type { RouteRecordRaw } from 'vue-router'

const noteCreateEdit = () => import('components/modules/Notes/CreateEdit.vue')

export const noteCreate: RouteRecordRaw = {
	component: noteCreateEdit,
	name: 'noteCreate',
	path: '/notes/create',
	meta: {
		title: 'Notiz anlegen',
		auth: true,
		limited: routesLimited.can_post,
		subs: [routesLimited.subModules.notes],
	},
}
export const noteView: RouteRecordRaw = {
	component: () => import('components/modules/Notes/View.vue'),
	name: 'noteView',
	path: '/notes/:noteId',
	props: castRouteIds,
	meta: { title: 'Notiz', subs: [routesLimited.subModules.notes] },
}
export const noteEdit: RouteRecordRaw = {
	component: noteCreateEdit,
	name: 'noteEdit',
	path: '/notes/:noteId/edit',
	props: castRouteIds,
	meta: {
		title: 'Notiz bearbeiten',
		subs: [routesLimited.subModules.notes],
	},
}
export const notes: RouteRecordRaw = {
	component: () => import('components/modules/Notes/Notes.vue'),
	meta: {
		title: 'Notizen',
	},
	name: 'notes',
	path: 'notes/',
}
